import script from "./VideoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoModal.vue?vue&type=script&setup=true&lang=js"

import "./VideoModal.vue?vue&type=style&index=0&id=5cfcb64a&lang=scss&scoped=true"
import "./VideoModal.vue?vue&type=style&index=1&id=5cfcb64a&lang=scss"

import exportComponent from "/Users/matteo.direnzo/Documents/TVA/eni-digit_eni-storia/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cfcb64a"]])

export default __exports__